<template>
  <v-container fluid>
    <v-row v-if="startDate && endDate" align="center" justify="center">
      <v-col cols="12" align="center" justify="center">
        <subscriptions-per-product :startDate="startDate" :endDate="endDate" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { BILLING_SUMMARY_QUERY } from "@/constants/graphql/billing/billing";

import SubscriptionsPerProduct from "@/components/billing/components/SubscriptionsPerProduct";

export default {
  name: "BillingDashboard",
  components: { SubscriptionsPerProduct },

  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
